var BarGraphConsts = /** @class */ (function () {
    function BarGraphConsts() {
    }
    BarGraphConsts.defaultBorderColor = '#7f939f';
    BarGraphConsts.defaultBackgroundColor = 'rgba(255,255,255,0)';
    BarGraphConsts.defaultBarColor = '#3695ff';
    BarGraphConsts.defaultUpperLimit = 90;
    BarGraphConsts.defaultLowerLimit = 10;
    BarGraphConsts.defaultUpperLimitColor = '#ff4448';
    BarGraphConsts.defaultLowerLimitColor = '#6344ff';
    BarGraphConsts.defaultCalibrationDigitFont = '12px sans-serif';
    BarGraphConsts.defaultCalibrationPercentageFont = '12px Microsoft YaHei';
    BarGraphConsts.defaultCalibrationColor = '#333333';
    BarGraphConsts.defaultIntegerDigits = 3;
    BarGraphConsts.defaultFractionDigits = 0;
    return BarGraphConsts;
}());
export { BarGraphConsts };
